/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Step2_TitleInputs */

const en_serve_step2_title = /** @type {(inputs: Serve_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Install Claude Code and sign in`)
};

const id_serve_step2_title = /** @type {(inputs: Serve_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Pasang Claude Code dan masuk`)
};

/**
* | output |
* | --- |
* | "2. Install Claude Code and sign in" |
*
* @param {Serve_Step2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_step2_title = /** @type {((inputs?: Serve_Step2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Step2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_step2_title(inputs)
	return en_serve_step2_title(inputs)
});